import React from "react";

function formatURL(url){
    return `${process.env.PUBLIC_URL}/${url}`
}

function formatLines(description) {
    if(description != null && description.includes("/n")) {
        const myArray = description.split("/n");
        let i = myArray.length-1;
        if(i == 1) {
            let text01 = myArray[0];
            let text02 = myArray[1];
            return(
                <p>{text01}<br />{text02}</p>
            );
        }
        else if(i == 2) {
            let text01 = myArray[0];
            let text02 = myArray[1];
            let text03 = myArray[2];
            return(
                <p>{text01}<br />{text02}<br />{text03}</p>
            );
        }
        else if(i == 3) {
            let text01 = myArray[0];
            let text02 = myArray[1];
            let text03 = myArray[2];
            let text04 = myArray[3];
            return(
                <p>{text01}<br />{text02}<br />{text03}<br />{text04}</p>
            );
        }
        else if(i == 4) {
            let text01 = myArray[0];
            let text02 = myArray[1];
            let text03 = myArray[2];
            let text04 = myArray[3];
            let text05 = myArray[4];
            return(
                <p>{text01}<br />{text02}<br />{text03}<br />{text04}<br />{text05}</p>
            );
        }
    }
    else {
        return(
            <p>{description}</p>
        );
    }
}

export { formatURL, formatLines }